import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { FormField, useFormContext } from "../../../../components/Form";
import { TextInput } from "../../../../components/Inputs";
import styles from "../../CommonContactForm.module.scss";
export const FormTextInput = ({ id, label, placeholder, disclaimer, validationRules, matchingFieldId, mathchingFieldErrorMessage, dataTestId = "formTextInput", mode, isLocked, }) => {
    const { watch, trigger, formState } = useFormContext();
    const matchingFieldValue = watch(matchingFieldId);
    useEffect(() => {
        if (matchingFieldId && formState.errors[id]) {
            trigger(id);
        }
    }, [matchingFieldId, formState.errors, matchingFieldValue, trigger, id]);
    return (_jsx(FormField, { id: id, className: styles.formField, name: id, defaultValue: "", showCustomError: true, render: ({ field, fieldState: { error } }) => (_jsx(TextInput, { ...field, placeholder: placeholder, dataTestId: dataTestId, isOptional: !validationRules.required, mode: mode, label: label, isLocked: isLocked, isError: !!error, errorText: error?.message, isHelperTextVisible: true, helperText: disclaimer })), validation: {
            ...validationRules,
            validate: (value) => {
                if (!matchingFieldId || !matchingFieldValue) {
                    return true;
                }
                return value === matchingFieldValue || mathchingFieldErrorMessage;
            },
        } }));
};
//# sourceMappingURL=FormTextInput.js.map